import { tokenizeRoute, UPDATE_REVIEW_ARCHIVAL_STATUS } from 'query/routes';
import { getCsrfToken } from 'query';

export const updateReviewIsArchived = async (
  reviewId: string,
  reviewerId: number,
  archived: boolean
) => {
  const url = tokenizeRoute(UPDATE_REVIEW_ARCHIVAL_STATUS, {
    reviewer_id: reviewerId,
    review_id: reviewId,
  });

  return fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': getCsrfToken(),
    },
    body: JSON.stringify({ review: { archived: String(archived) } }),
  }).then((res) => (res.ok ? res.json() : res));
};
